/* opc.js: behaviour for the opc-* sections (template page.hyt-opch). No dependencies.
   Every opc section renders a <script defer> for this file, so it guards against running twice. */
(function () {
  'use strict';
  if (window.__opcInit) return;
  window.__opcInit = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) { return '$' + (Math.round(cents) / 100).toFixed(2); }

  var CHEV_L = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- in-page scrolling (clears the pinned store header) ---------- */
  function headerOffset() {
    var hd = $('.pc-header') || $('header');
    var h = hd ? hd.getBoundingClientRect().height : 0;
    return Math.min(Math.max(h, 0), 140) + 12;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-opc-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var el = document.getElementById(href.slice(1));
    if (!el) return;
    e.preventDefault();
    scrollToEl(el);
  });

  /* ---------- countdown bar ---------- */
  function initBar(bar) {
    var mins = parseInt(bar.getAttribute('data-minutes'), 10) || 40;
    var key = 'opc_bar_end_' + mins;
    var timerEl = $('[data-opc-timer]', bar);
    var mem = 0;
    function nextEnd() {
      var v = mem;
      try { v = parseInt(sessionStorage.getItem(key), 10) || mem; } catch (err) {}
      var now = Date.now();
      if (!v || v <= now) {
        v = now + mins * 60000;
        try { sessionStorage.setItem(key, String(v)); } catch (err) {}
      }
      mem = v;
      return v;
    }
    var end = nextEnd();
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { end = nextEnd(); left = end - Date.now(); }
      var sec = Math.floor(left / 1000), m = Math.floor(sec / 60), s = sec % 60;
      if (timerEl) timerEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    setInterval(tick, 1000);
    var best = $('[data-opc-best]');
    var pct = best ? parseInt(best.getAttribute('data-opc-best'), 10) : 0;
    $$('[data-opc-pct]', bar).forEach(function (n) { n.textContent = pct > 0 ? pct + '%' : ''; });
  }

  /* ---------- horizontal carousels (loop at both ends) ---------- */
  function initRail(rail) {
    var track = $('[data-opc-track]', rail);
    if (!track) return;
    function step(dir) {
      var first = track.firstElementChild;
      if (!first) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth - 2;
      if (max <= 0) return;
      if (dir > 0 && track.scrollLeft >= max) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && track.scrollLeft <= 2) { track.scrollTo({ left: max + 2, behavior: 'smooth' }); return; }
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    $$('[data-opc-prev]', rail).forEach(function (b) { b.addEventListener('click', function () { step(-1); }); });
    $$('[data-opc-next]', rail).forEach(function (b) { b.addEventListener('click', function () { step(1); }); });
  }

  /* ---------- tabs (science, FAQ, add-ons) ---------- */
  function initTabs(root) {
    function mine(el) { return el.closest('[data-opc-tabs]') === root; }
    var tabs = $$('[data-opc-tab]', root).filter(mine);
    var panels = $$('[data-opc-panel]', root).filter(mine);
    var n = Math.max(tabs.length, panels.length);
    if (!n) return;
    var cur = 0;
    function show(i) {
      cur = ((i % n) + n) % n;
      tabs.forEach(function (t) {
        var on = parseInt(t.getAttribute('data-opc-tab'), 10) === cur;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.hidden = parseInt(p.getAttribute('data-opc-panel'), 10) !== cur; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-opc-tab'), 10)); }); });
    $$('[data-opc-tprev]', root).filter(mine).forEach(function (b) { b.addEventListener('click', function () { show(cur - 1); }); });
    $$('[data-opc-tnext]', root).filter(mine).forEach(function (b) { b.addEventListener('click', function () { show(cur + 1); }); });
  }

  /* ---------- product gallery ---------- */
  function initGallery(g) {
    var track = $('[data-opc-gtrack]', g);
    if (!track) return;
    var thumbs = $$('[data-opc-gthumb]', g);
    var n = track.children.length, cur = 0, raf = 0;
    function mark(i) {
      cur = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-on', k === i);
        t.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      var th = thumbs[i], strip = th && th.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        strip.scrollTo({ left: th.offsetLeft - strip.clientWidth / 2 + th.clientWidth / 2, behavior: 'smooth' });
      }
    }
    function go(i) {
      if (!n) return;
      i = ((i % n) + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      mark(i);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var prev = $('[data-opc-gprev]', g), next = $('[data-opc-gnext]', g);
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== cur && i >= 0 && i < n) mark(i);
      });
    }, { passive: true });
  }

  /* ---------- cart ---------- */
  function openDrawer() {
    try { if (window.__BBFIX_OPEN) { window.__BBFIX_OPEN(); return true; } } catch (err) {}
    try { if (window.__BBFIX_SHOWCART) { window.__BBFIX_SHOWCART(); return true; } } catch (err) {}
    return false;
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function addItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) throw new Error((j && (j.description || j.message)) || 'add failed');
        return j;
      });
    });
  }
  function afterAdd(mode) {
    if (mode === 'checkout') { window.location.href = '/checkout'; return; }
    if (!openDrawer()) window.location.href = '/checkout';
  }

  /* Any [data-opc-add] button: add one variant (with its plan when data-plan is set), then open the drawer. */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-opc-add]');
    if (!b || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var item = { id: parseInt(b.getAttribute('data-vid'), 10), quantity: parseInt(b.getAttribute('data-qty') || '1', 10) || 1 };
    var plan = parseInt(b.getAttribute('data-plan') || '0', 10);
    if (plan) item.selling_plan = plan;
    if (!item.id) return;
    var modal = b.closest('[data-opc-modal]');
    b.setAttribute('aria-busy', 'true');
    addItems([item])
      .then(function () { if (modal) closeModal(modal); afterAdd('drawer'); })
      .catch(function () { b.classList.add('is-err'); setTimeout(function () { b.classList.remove('is-err'); }, 1600); })
      .then(function () { b.removeAttribute('aria-busy'); });
  });

  /* ---------- buy box ---------- */
  function initBuy(root) {
    var dataEl = $('script[data-opc-json]', root);
    if (!dataEl) return;
    var d;
    try { d = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var tiers = d.tiers || [];
    if (!tiers.length) return;
    var st = { t: Math.min(Math.max(d.def || 0, 0), tiers.length - 1), type: 'sub' };
    var pills = $$('[data-opc-tier]', root);
    var types = $$('[data-opc-type]', root);
    var atc = $('[data-opc-atc]', root);
    var errEl = $('[data-opc-err]', root);

    function put(sel, text, show) {
      $$(sel, root).forEach(function (el) {
        el.textContent = text;
        if (show !== undefined) el.hidden = !show;
      });
    }
    function paint() {
      var t = tiers[st.t], sub = st.type === 'sub', m = t.months || 1;
      pills.forEach(function (p) {
        var i = parseInt(p.getAttribute('data-opc-tier'), 10), on = i === st.t, tt = tiers[i];
        p.classList.toggle('is-on', on);
        p.setAttribute('aria-checked', on ? 'true' : 'false');
        if (tt) {
          var cardPrice = sub ? tt.sub : tt.once, cardSave = tt.strike - cardPrice, pc = sub ? tt.subPct : tt.oncePct;
          var cp = $('[data-opc-card-price]', p), cs = $('[data-opc-card-strike]', p), sv = $('[data-opc-save]', p);
          if (cp) cp.textContent = money(cardPrice);
          if (cs) { cs.textContent = money(tt.strike); cs.hidden = !(tt.strike > cardPrice); }
          if (sv) {
            sv.textContent = (d.saveLabel || 'You save [save] ([pct])').replace('[save]', money(cardSave)).replace('[pct]', pc + '%');
            sv.hidden = !(cardSave > 0);
          }
        }
      });
      types.forEach(function (c) {
        var on = c.getAttribute('data-opc-type') === st.type;
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      put('[data-opc-delivery]', t.delivery || '');
      put('[data-opc-sub-price]', money(t.sub / m));
      put('[data-opc-sub-strike]', money(t.strike / m), t.strike > t.sub);
      put('[data-opc-once-price]', money(t.once / m));
      put('[data-opc-once-strike]', money(t.strike / m), t.strike > t.once);
      var price = sub ? t.sub : t.once;
      put('[data-opc-atc-price]', money(price));
      put('[data-opc-atc-strike]', money(t.strike), t.strike > price);
      if (atc) atc.disabled = t.available === false;
    }

    pills.forEach(function (p) {
      p.addEventListener('click', function () { st.t = parseInt(p.getAttribute('data-opc-tier'), 10) || 0; paint(); });
    });
    types.forEach(function (c) {
      function pick() { st.type = c.getAttribute('data-opc-type'); paint(); }
      c.addEventListener('click', pick);
      c.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    if (atc) atc.addEventListener('click', function () {
      if (atc.getAttribute('aria-busy') === 'true') return;
      var t = tiers[st.t], sub = st.type === 'sub';
      var main = { id: t.vid, quantity: t.qty || 1 };
      if (sub && t.plan) main.selling_plan = t.plan;
      var gifts = sub ? (d.gifts || []) : [];
      var sticks = sub && d.sticks ? d.sticks : 0;
      atc.setAttribute('aria-busy', 'true');
      if (errEl) errEl.hidden = true;
      if (d.after === 'checkout') window.__BBFIX_NO_AUTOOPEN = true;

      (gifts.length || sticks ? getCart() : Promise.resolve(null))
        .then(function (cart) {
          var have = {}, haveSticks = false;
          ((cart && cart.items) || []).forEach(function (it) {
            have[it.id] = true;
            if (it.id === sticks && it.properties && it.properties._pc_gift === 'sticks') haveSticks = true;
          });
          var items = [main];
          gifts.forEach(function (g) { if (!have[g]) items.push({ id: g, quantity: 1 }); });
          /* Fiber Sticks sampler: its own line, tagged so the bbfix GIFTCAP net keeps it. */
          var withSticks = sticks && !haveSticks;
          if (withSticks) items.push({ id: sticks, quantity: 1, properties: { _pc_gift: 'sticks' } });
          /* A gift that cannot be added must never block the bundle itself:
             retry without the sampler, then with the bundle alone. */
          return addItems(items).catch(function (err) {
            var noSticks = items.filter(function (it) { return it.id !== sticks; });
            var retry = withSticks && noSticks.length ? addItems(noSticks) : Promise.reject(err);
            return retry.catch(function (err2) {
              if (items.length > 1) return addItems([main]);
              throw err2;
            });
          });
        })
        .then(function () { afterAdd(d.after); })
        .catch(function () {
          if (errEl) { errEl.textContent = d.errText || 'Something went wrong. Please try again.'; errEl.hidden = false; }
        })
        .then(function () { atc.removeAttribute('aria-busy'); });
    });

    paint();
  }

  /* ---------- pop-ups ---------- */
  var lastFocus = null;
  function openModal(m) {
    lastFocus = document.activeElement;
    m.hidden = false;
    document.documentElement.classList.add('opc-lock');
    var x = $('.opc-modal__x', m);
    if (x) x.focus();
  }
  function closeModal(m) {
    m.hidden = true;
    if (!$('[data-opc-modal]:not([hidden])')) document.documentElement.classList.remove('opc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('[data-opc-open]');
    if (o) {
      var m = document.getElementById(o.getAttribute('data-opc-open'));
      if (m) { e.preventDefault(); openModal(m); }
      return;
    }
    var c = e.target.closest && e.target.closest('[data-opc-close]');
    if (c) {
      var mm = c.closest('[data-opc-modal]');
      if (mm) closeModal(mm);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('[data-opc-modal]:not([hidden])').forEach(closeModal);
  });

  /* ---------- reviews: read more, search, pages ---------- */
  function initReviews(root) {
    var items = $$('[data-opc-ritem]', root);
    if (!items.length) return;
    var per = parseInt(root.getAttribute('data-per'), 10) || 5;
    var clip = parseInt(root.getAttribute('data-clip'), 10) || 260;
    var moreLabel = root.getAttribute('data-more') || 'Read More';
    var nav = $('[data-opc-rpages]', root);
    var q = $('[data-opc-rq]', root);
    var go = $('[data-opc-rgo]', root);
    var empty = $('[data-opc-rempty]', root);
    var list = items, page = 0;

    items.forEach(function (it) {
      it.__opcText = (it.textContent || '').replace(/\s+/g, ' ').toLowerCase();
      var body = $('[data-opc-rbody]', it);
      if (!body) return;
      var full = body.textContent.trim();
      if (full.length <= clip) return;
      body.textContent = full.slice(0, clip).replace(/\s+\S*$/, '') + '...';
      var more = document.createElement('button');
      more.type = 'button';
      more.className = 'opc-rev__rm';
      more.textContent = moreLabel;
      more.addEventListener('click', function () { body.textContent = full; });
      body.appendChild(more);
    });

    function render(scroll) {
      var pages = Math.max(1, Math.ceil(list.length / per));
      page = Math.min(page, pages - 1);
      items.forEach(function (it) { it.hidden = true; });
      list.slice(page * per, page * per + per).forEach(function (it) { it.hidden = false; });
      if (empty) empty.hidden = list.length > 0;
      if (nav) {
        nav.innerHTML = '';
        if (pages > 1) {
          var add = function (html, target, cls, label) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = cls;
            b.innerHTML = html;
            if (label) b.setAttribute('aria-label', label);
            b.addEventListener('click', function () { page = target; render(true); });
            nav.appendChild(b);
            return b;
          };
          add(CHEV_L, Math.max(0, page - 1), 'opc-rev__nav', 'Previous page');
          for (var i = 0; i < pages; i++) {
            var pb = add(String(i + 1), i, i === page ? 'is-on' : '', 'Page ' + (i + 1));
            if (i === page) pb.setAttribute('aria-current', 'page');
          }
          add(CHEV_R, Math.min(pages - 1, page + 1), 'opc-rev__nav', 'Next page');
        }
      }
      if (scroll) {
        var lst = $('[data-opc-rlist]', root);
        if (lst && lst.getBoundingClientRect().top < 0) scrollToEl(lst);
      }
    }
    function search() {
      var term = q ? q.value.trim().toLowerCase() : '';
      list = term ? items.filter(function (it) { return it.__opcText.indexOf(term) >= 0; }) : items;
      page = 0;
      render(false);
    }
    if (q) {
      q.addEventListener('input', search);
      q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); search(); } });
    }
    if (go) go.addEventListener('click', search);
    render(false);
  }

  /* ---------- boot ---------- */
  var INITS = [
    ['[data-opc-bar]', initBar],
    ['[data-opc-rail]', initRail],
    ['[data-opc-tabs]', initTabs],
    ['[data-opc-gallery]', initGallery],
    ['[data-opc-buy]', initBuy],
    ['[data-opc-reviews]', initReviews]
  ];
  function boot(scope) {
    INITS.forEach(function (pair) { $$(pair[0], scope).forEach(pair[1]); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
